import React from "react";
import { Typography, useMediaQuery } from "@mui/material";
import Iconify from "../Iconify";

function Feedback({ task }) {
  const is_mobile_view = useMediaQuery("(max-width:600px)");

  const issues =
    task.task_checklist_stats?.improvements_stats?.total_count || 0;
  const completed =
    task.task_checklist_stats?.improvements_stats?.completed_count || 0;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      {completed === issues ? (
        <div className="feedback-complete">
          <Typography
            sx={{
              color: "primary.main",
              fontWeight: 500,
              fontSize: "0.7rem",
            }}
          >
            {!is_mobile_view && (
              <span className="px-2 fw-bold">
                {completed} / {issues}
              </span>
            )}
            {is_mobile_view ? " Feedback" : "All Implemented"}
          </Typography>
          <Iconify
            color="primary.main"
            fontSize="14px"
            icon={"icon-park-twotone:thumbs-up"}
          />
        </div>
      ) : (
        <div className="feedback-stats">
          <Iconify
            color="#1890FF"
            fontSize="16px"
            icon="codicon:feedback"
            sx={{ marginRight: "5px" }}
          />
          {!is_mobile_view && (
            <>
              <Typography
                sx={{
                  color: "#1890FF",
                  fontWeight: 500,
                  fontSize: "0.7rem",
                }}
              >
                {completed}
              </Typography>
              <Typography
                sx={{
                  marginLeft: 0.5,
                  marginRight: 0.75,
                  fontWeight: 500,
                  fontSize: "0.7rem",
                }}
              >
                / {issues}
              </Typography>
            </>
          )}
          <Typography sx={{ fontSize: "0.7rem", fontWeight: 500 }}>
            Feedback
          </Typography>
        </div>
      )}
    </div>
  );
}

export default Feedback;
